module.exports = __webpack_public_path__ + "img/vpc15.e679e46.png";